export default "__VITE_ASSET__DTPZJefM__"